import React from 'react';
import Divider from '@material-ui/core/Divider';
import _ from 'lodash';
import {
  MobileDesignConfigClasses,
  MobileDesignConfigState,
  MobileDesignImageKey
} from '../MobileDesignConfig.types';
import { MediaConfigState } from '../hooks/useMediaConfig';
import { DraggableImage } from '../..';
import { UNIT } from '../../../constants';
import { MAX_FILE_SIZE, ALLOWED_IMAGE_EXTENSIONS, MAX_SLIDER_IMAGES } from '../MobileDesignConfig.services';

const DRAG_DROP_TEXT = "Drag & Drop l'image (500Ko max)";

const buildPictureList = (img?: string | null) => (img ? [{ imageUrl: img }] : []);

const DraggableImageComponent = DraggableImage as unknown as React.ComponentType<any>;

interface MediaSectionProps {
  classes: MobileDesignConfigClasses;
  state: MobileDesignConfigState;
  mediaState?: MediaConfigState;
  onSliderImageChange: (index: number, image: string) => void;
  onSliderImageRemove: (index: number) => void;
  onDesignImageUpload: (image: string, key: MobileDesignImageKey) => void;
  onDesignImageRemove: (key: MobileDesignImageKey) => void;
  onDisableLoader: () => void;
}

const cropProps = {
  width: 'auto',
  height: UNIT * 10.6875,
  backgroundColor: '#F1F4F7',
  borderRadius: UNIT
};

export const MediaSection: React.FC<MediaSectionProps> = ({
  classes,
  state,
  mediaState,
  onSliderImageChange,
  onSliderImageRemove,
  onDesignImageUpload,
  onDesignImageRemove,
  onDisableLoader
}) => {
  const {
    loadingCropper,
  } = state;

  const slides = mediaState?.slides || [];
  const slidesWithNulls = Array(MAX_SLIDER_IMAGES).fill(null).map((_, index) => 
    slides[index] !== undefined ? slides[index] : null
  );
  
  const loyaltyImage = mediaState?.loyaltyImage;
  const ordersImage = mediaState?.ordersImage;
  const profileImage = mediaState?.profileImage;

  return (
    <div>
      <div>
        <p>
          <span className={classes.designText}>Slider</span> <i>(3 images maximum)</i>
        </p>
        {slidesWithNulls.map((slider, index) => (
          <div className={classes.cropStyle} key={`slider-${index}`}>
            <DraggableImageComponent
              multiple={false}
              loadingCropper={loadingCropper}
              disableLoader={onDisableLoader}
              maxFileSize={MAX_FILE_SIZE}
              picture={buildPictureList(slider)}
              fileType
              isDesign
              setCroppedImage={croppedImage => onSliderImageChange(index, croppedImage)}
              handleRemove={() => onSliderImageRemove(index)}
              defaultText={DRAG_DROP_TEXT}
              imgExtension={ALLOWED_IMAGE_EXTENSIONS}
              cropProps={cropProps}
              aspect={3}
              cropStyle={classes.crop}
            />
          </div>
        ))}
      </div>
      <Divider className={classes.dividerStyle} />
      <div>
        <p>
          <span className={classes.designText}>Ma fidélité</span> <i>(1 image maximum)</i>
        </p>

        <div className={classes.cropStyle}>
          <DraggableImageComponent
            multiple={false}
            loadingCropper={loadingCropper}
            disableLoader={onDisableLoader}
            maxFileSize={MAX_FILE_SIZE}
            picture={buildPictureList(loyaltyImage)}
            fileType
            isDesign
            setCroppedImage={croppedImage => onDesignImageUpload(croppedImage, MobileDesignImageKey.LOYALTY)}
            handleRemove={() => onDesignImageRemove(MobileDesignImageKey.LOYALTY)}
            imgExtension={ALLOWED_IMAGE_EXTENSIONS}
            defaultText={DRAG_DROP_TEXT}
            cropProps={cropProps}
            aspect={3}
            cropStyle={classes.crop}
          />
        </div>
      </div>
      <Divider className={classes.dividerStyle} />
      <div>
        <p>
          <span className={classes.designText}>Mes commandes</span> <i>(1 image maximum)</i>
        </p>

        <div className={classes.myOrdersStyle}>
          <DraggableImageComponent
            multiple={false}
            loadingCropper={loadingCropper}
            disableLoader={onDisableLoader}
            maxFileSize={MAX_FILE_SIZE}
            picture={buildPictureList(ordersImage)}
            fileType
            isDesign
            setCroppedImage={croppedImage => onDesignImageUpload(croppedImage, MobileDesignImageKey.ORDERS)}
            handleRemove={() => onDesignImageRemove(MobileDesignImageKey.ORDERS)}
            imgExtension={ALLOWED_IMAGE_EXTENSIONS}
            defaultText={DRAG_DROP_TEXT}
            cropProps={cropProps}
            aspect={1}
            cropStyle={classes.crop}
          />
        </div>
      </div>
      <Divider className={classes.dividerStyle} />
      <div>
        <p>
          <span className={classes.designText}>Mon profil</span> <i>(1 image maximum)</i>
        </p>

        <div className={classes.myOrdersStyle}>
          <DraggableImageComponent
            multiple={false}
            loadingCropper={loadingCropper}
            disableLoader={onDisableLoader}
            maxFileSize={MAX_FILE_SIZE}
            picture={buildPictureList(profileImage)}
            fileType
            isDesign
            setCroppedImage={croppedImage => onDesignImageUpload(croppedImage, MobileDesignImageKey.PROFILE)}
            handleRemove={() => onDesignImageRemove(MobileDesignImageKey.PROFILE)}
            imgExtension={ALLOWED_IMAGE_EXTENSIONS}
            defaultText={DRAG_DROP_TEXT}
            cropProps={cropProps}
            aspect={1}
            cropStyle={classes.crop}
          />
        </div>
      </div>
    </div>
  );
};

